export default class DataSetColDateTimeEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 24;
    alignment = "Center";
    displayFormat = "yyyy-MM-dd HH:mm:ss";
    type = "DataTime";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColDateTimeEditor.js